import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent,appConfig
  //  {
  // providers: [
  //   provideRouter(routes),
    //provideHttpClient(),
//     provideAnimations()
//   ]
// }
).catch(err => console.error(err));
